// extracted by mini-css-extract-plugin
module.exports = {"lia-message-introduction":"MessageIntroduction_lia-message-introduction___mMAN"};